// @ts-check

import { mutationOptions } from "@tanstack/react-query"
import { cancelSessionStream, getSessionStream, StreamEvents } from "../api"
import { handleStream, setStreamQueriesData } from "./utils"

const ChatStreamQueryKeys = {
}

const ChatStreamQueryOptions = {
}

const ChatStreamMutationOptions = {
  // TODO: handle edit and regenerate streams where we have to mutate the current chat session messages
  /**
   * @param {Object} params
   * @param {() => string} params.getUserToken
   * @param {(payload: import("../api").StreamEventsPayload) => void} [params.onStreamEvent]
   */
  GET_CHAT_STREAM: ({ getUserToken, onStreamEvent }) => mutationOptions({
    /**
     * @param {Object} params
     * @param {string} params.sessionId
     * @param {AbortSignal} [params.signal]
     */
    mutationFn: async ({ sessionId, signal }) => {
      const readable = getSessionStream(sessionId, getUserToken(), { signal })
      return handleStream(readable, {
        sessionId,
        getUserToken,
        onStreamEvent,
      })
    },
    async onSuccess(data, variables, mutateResult, context) {
      await setStreamQueriesData(context.client, data, variables.sessionId)
    },
  }),
  /**
   * @param {Object} params
   * @param {string} params.sessionId
   * @param {string} params.userToken
   */
  CANCEL_CHAT_STREAM: ({ sessionId, userToken }) => mutationOptions({
    mutationFn: () => cancelSessionStream(sessionId, userToken),
  }),
}

export {
  ChatStreamQueryKeys,
  ChatStreamQueryOptions,
  ChatStreamMutationOptions,
}
